import React, { useState } from "react";
import { Row, Col } from "reactstrap";

import moment from "moment";
import PageHead from "../../../../component/pageHead/PageHead";
import CustomButton from "../../../../component/CustomButton/CustomButton";
import Input from "../Input";
// import Input from "../../../../component/InputComp/InputComp";

function EmployerScheduleUploadForm(props) {
  const [errors, setErrors] = useState({});
  const [file, setFile] = useState(null);
  // const [month, setMonth] = useState("");
  const [date, setDate] = useState("");
  // const [year, setYear] = useState("");
  const [amount, setAmount] = useState("");
  const [description, setDescription] = useState("");

  function handleSubmit(e) {
    e.preventDefault();

    if (!validate()) return props.onError();

    const formData = new FormData();

    formData.append("date", moment(date).format("YYYY-MM-DD"));
    formData.append("totalAmount", amount);
    formData.append("desc", description);
    formData.append("myfile", file);

    props.onSubmit(formData);
  }

  function handleChange(e) {
    const name = e.target.name;
    const value = e.target.value;
    const file = e.target.files || [];

    if (name === "date") {
      setDate(value);
    }

    if (name === "amount") setAmount(value);
    if (name === "description") setDescription(value);
    if (name === "file") setFile(file[0]);
  }

  function validate() {
    const e = {};

    if (!date) {
      e.date = "This field is required";
    }

    setErrors(e);

    return !Object.keys(e).length;
  }

  return (
    <>
      <PageHead
        title="EMPLOYER SCHEDULE UPLOAD"
        containerStyles={{ width: "100%" }}
      />
      <form onSubmit={handleSubmit}>
        <Row>
          <Col className="my-2" md={6}>
            <Input
              type="date"
              value={date}
              name="date"
              onChange={handleChange}
              errorMessage={errors.date}
            />
          </Col>
          {/* <Col className="my-2" md={6}>
            <Input
              value={year}
              name="year"
              onChange={handleChange}
              errorMessage={errors.year}
              placeholder="Year*"
            />
          </Col> */}
          <Col className="my-2" md={6}>
            <Input
              value={amount}
              name="amount"
              onChange={handleChange}
              placeholder="Amount"
            />
          </Col>
          <Col className="my-2" xs={12}>
            <Input
              value={description}
              placeholder="description"
              name="description"
              onChange={handleChange}
              type="textarea"
            />
          </Col>
          <Col className="my-2" xs={12}>
            <Input name="file" onChange={handleChange} type="file" />
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col className="my-2" sm={3}>
            <CustomButton
              type="submit"
              buttonClasses="btn-block"
              buttonText="Submit"
            />
          </Col>
        </Row>
      </form>
    </>
  );
}

EmployerScheduleUploadForm.defaultProps = {
  onSubmit: function() {},
  onError: function() {}
};

export default EmployerScheduleUploadForm;
